import { NavigationContainer } from "@react-navigation/native";
import { useEffect, useState } from "react";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import Loading from "./src/components/Loading";
import AuthProvider from "./src/contexts/auth";
import GlobalProvider from "./src/contexts/global";
import PaymentProvider from "./src/contexts/payment";
import Routes from "./src/routes";
import { toastConfig } from "./src/services/Config";
import { LayoutAnimation } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { QueryClient, QueryClientProvider } from "react-query";
import { SecureStorage } from "@helpers/storage";

export default function App() {
  const [isSplashFinish, setIsSplashFinish] = useState(false);
  const [onboarded, setOnboarded] = useState();
  const queryClient = new QueryClient();

  useEffect(() => {
    (async () => {
      await SecureStorage.deleteItemAsync("TokenApi");
      await SecureStorage.deleteItemAsync("TokenUser");
      const onboarded = await AsyncStorage.getItem("ONBOARDED");
      setOnboarded(JSON.parse(onboarded));
    })();
  }, []);

  // const TextEncodingPolyfill = require("text-encoding");
  // const BigInt = require("big-integer");
  // Object.assign(global, {
  //   TextEncoder: TextEncodingPolyfill.TextEncoder,
  //   TextDecoder: TextEncodingPolyfill.TextDecoder,
  //   BigInt: BigInt,
  // });

  LayoutAnimation.linear();

  if (!isSplashFinish)
    return <Loading message="" setIsSplashFinish={setIsSplashFinish} />;
  return (
    <NavigationContainer>
      <GlobalProvider>
        <AuthProvider>
          <PaymentProvider>
            <QueryClientProvider client={queryClient}>
              <Routes onboarded={false} />
              <Toast config={toastConfig} />
            </QueryClientProvider>
          </PaymentProvider>
        </AuthProvider>
      </GlobalProvider>
    </NavigationContainer>
  );
}
